import { render } from "./SelRegionDiffer.vue?vue&type=template&id=47b57751&scoped=true"
import script from "./SelRegionDiffer.vue?vue&type=script&lang=js"
export * from "./SelRegionDiffer.vue?vue&type=script&lang=js"

import "./SelRegionDiffer.vue?vue&type=style&index=0&id=47b57751&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b57751"]])

export default __exports__